import { CommonModule, JsonPipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, RouterOutlet } from '@angular/router';
import { NgbCalendar, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { OutOfOfficeService } from '../../../Model/OutOfOffice/out-of-office.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { Subject } from 'rxjs';
import moment from 'moment';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-out-of-office-load',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, FormsModule, JsonPipe, DataTablesModule, NgbDropdownModule, LoaderComponent, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './out-of-office-load.component.html',
  styleUrl: './out-of-office-load.component.scss'
})
export class OutOfOfficeLoadComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  user = [] as any;
  OutOfOfficeLoad = [];

  Filter = {
    ModuleMasterId: 5,
    EmpMasterID: null,
    FromDate: null as any,
    ToDate: null as any,
    ApprovalStatus: 'ALL',
    IsWithdraw: false
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    private outofoffice: OutOfOfficeService,
    private session: SessionService,
    private calendar: NgbCalendar,
    private dateFromat: CustomDateParserFormatter,
    private modalService: NgbModal,
    protected common: CommonService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.Filter.EmpMasterID = this.user.UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    //this.GetEmployeeLeaveDetails();
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.Search();
    } else {
      form.submitted = true;
    }
  }

  Search() {
    if (this.Filter.IsWithdraw) {
      this.OutOfOfficeAttendanceDetails();
    } else {
      this.GetOutOfOfficeDetails();
    }
  }

  GetOutOfOfficeDetails() {
    this.Filter.EmpMasterID = this.user.UserId;
    if (moment(this.dateFormat.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDate), 'DD MMM YYYY'))) {
      this.isDisabled = true;
      this.outofoffice.OutOfOfficeAttendanceDetails({
        SelectType: 2,
        ESS_OutOfOfficeAttendanceDetailsId: 0,
        EmpMasterID: this.Filter.EmpMasterID,
        ApprovalStatus: this.Filter.ApprovalStatus,
        FromDate: this.dateFormat.format(this.Filter.FromDate),
        ToDate: this.dateFormat.format(this.Filter.ToDate),
        BranchId: 0,
        ClientId: 0,
        SiteId: 0,
        AttendanceDate: 0,

      }).subscribe({
        next: (response) => {
          this.OutOfOfficeLoad = response.Table;
          console.log(this.OutOfOfficeLoad);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  OutOfOfficeAttendanceDetails() {
    this.isDisabled = true;
    this.Filter.EmpMasterID = this.user.UserId;
    this.Filter.EmpMasterID = this.user.UserId;
    if (moment(this.dateFormat.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDate), 'DD MMM YYYY'))) {
      this.isDisabled = true;
      this.outofoffice.OutOfOfficeAttendanceDetails({
        SelectType: 3,
        ESS_OutOfOfficeAttendanceDetailsId: 0,
        EmpMasterID: this.Filter.EmpMasterID,
        ApprovalStatus: this.Filter.ApprovalStatus,
        FromDate: '',//this.dateFormat.format(this.Filter.FromDate),
        ToDate: '',//this.dateFormat.format(this.Filter.ToDate),
        BranchId: 0,
        ClientId: 0,
        SiteId: 0,
        AttendanceDate: 0,

      }).subscribe({
        next: (response) => {
          this.OutOfOfficeLoad = response.Table;
          console.log(this.OutOfOfficeLoad);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  async SaveWithdrawmDetails(index: any) {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsView) {
        if (result) {
          if (result) {
            const data = {
              SelectType: 'WITHDRAWN',
              ESS_OutOfOfficeAttendanceDetailsID: index,
              EmpMasterId: 0,
              BranchID: 0,
              SiteID: 0,
              DesignationID: 0,
              DutyID: 0,
              ShiftMasterID: 0,
              AttendanceDate: 0,
              InTime: null,
              OutTime: null,
              Attachment: '',
              Reason: '',
              UserId: this.user.UserId
            }
            console.log('sdsdsa', data);
            this.isDisabled = true
            this.outofoffice.OutOfOfficeAttendanceDetailsInsert(data).subscribe({
              next: (response) => {
                if (response.Error_Code == '660') {
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.Search()
                    }
                  });
                }
                else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDate.day = 1;
          this.Filter.FromDate.month = 1;
          this.Filter.ToDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDate.day = 31;
          this.Filter.ToDate.month = 12;
        }
        this.Search();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Clear() {
    this.OutOfOfficeLoad = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'OutofOffice' + '/' + Text;
  }
}
